export default __webpack_public_path__ + "static/media/icon-feather-search.bf61dd0e.svg";